import { useMutation, MutationHookOptions } from '@apollo/client';
import MUTATION from '../operations/UpdateUserProposalInfluencersBudget.graphql';
import { Mutation, MutationupdateUserProposalInfluencersBudgetArgs } from '../../__generated__/globalTypes';

export const useUpdateUserProposalInfluencersBudgetMutation = (
  options?: MutationHookOptions<Mutation, MutationupdateUserProposalInfluencersBudgetArgs>
) => {
  const [callUpdateUserProposalInfluencersBudget, result] = useMutation<
    Mutation,
    MutationupdateUserProposalInfluencersBudgetArgs
  >(MUTATION, options);

  return { callUpdateUserProposalInfluencersBudget, ...result };
};

export type UpdateUserProposalInfluencersBudgetMutationFunction = Mutation['updateUserProposalInfluencersBudget'];
